import moment from 'moment'
import 'moment-timezone'

export const secondsDiff = (a, b) => {
  const now = moment(a)
  const end = moment(b)
  return now.diff(end, 'seconds');
}

export const formatTime = (time, tz, timeFormat) => {
  if (!time) return ''
  if (!tz) return moment.utc(time).format(timeFormat)
  return moment.utc(time).tz(tz).format(timeFormat)
}

export const formatTimeFromNow = (time, tz) => {
  if (!time) return ''
  if (!tz) return moment.utc(time).fromNow()
  return moment.utc(time).tz(tz).fromNow()
}

export const groupReportsByDay = (reports, tz, getTime = (report) => report.created_at) => {
  const zone = tz || 'UTC'
  const today = moment().tz(zone).startOf('day')
  const yesterday = moment(today).clone().subtract(1, 'day')

  const groups = []
  const indexByKey = {}

  for (const report of reports) {
    const day = moment.utc(getTime(report)).tz(zone).startOf('day')
    const key = day.format('YYYY-MM-DD')

    let label
    if (day.isSame(today, 'day')) label = 'Today'
    else if (day.isSame(yesterday, 'day')) label = 'Yesterday'
    else if (day.isSame(today, 'year')) label = day.format('D MMMM')
    else label = day.format('D MMMM YYYY')

    if (!(key in indexByKey)) {
      indexByKey[key] = groups.length
      groups.push({ key, label, items: [] })
    }
    groups[indexByKey[key]].items.push(report)
  }

  return groups
}

export const formatTimeFromNowNumeric = (time, tz) => {
  const now = moment().tz(tz)
  const target = moment(time).tz(tz)

  const diffInSeconds = Math.abs(now.diff(target, 'seconds'))

  if (diffInSeconds < 60) {
    return `${diffInSeconds}s`
  } else {
    const minutes = Math.floor(diffInSeconds / 60)
    return `${minutes}m`
  }
}
